import React, { useState } from "react";
import { usePlans } from "../hooks/usePlans";
import { saasApi } from "../api/saasApi";
import { useSubscription } from "../hooks/useSubscription";
import "../styles/saas.css";

export default function SubscriptionPage() {
  const { plans } = usePlans();
  const { data, refresh } = useSubscription();
  const [billingCycle, setBillingCycle] = useState("yearly");
  const [planSlug, setPlanSlug] = useState("starter");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    setLoading(true);
    setMessage("");
    try {
      const orderRes = await saasApi.createOrder({ plan_slug: planSlug, billing_cycle: billingCycle });
      const { order_id, key_id, amount, payment_id } = orderRes.data;

      if (!window.Razorpay) {
        setMessage("Razorpay checkout script not loaded. Add the script to public/index.html.");
        return;
      }

      const rzp = new window.Razorpay({
        key: key_id,
        amount,
        currency: "INR",
        name: "Beentara",
        description: `${planSlug} — ${billingCycle}`,
        order_id,
        handler: async (response) => {
          try {
            await saasApi.verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            await refresh();
            window.location.href = "/payment/success";
          } catch (err) {
            setMessage(err.data?.message || err.message);
            window.location.href = "/payment/failure";
          }
        },
        modal: { ondismiss: () => setLoading(false) },
      });
      rzp.open();
    } catch (err) {
      setMessage(err.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="saas-page">
      <h1>Subscription</h1>
      {data?.subscription && (
        <div className="saas-card saas-card--muted">
          <p>Current status: <strong>{data.subscription.status}</strong></p>
          {data.subscription.plan && <p>Plan: {data.subscription.plan.name}</p>}
        </div>
      )}

      <div className="saas-form" style={{ maxWidth: 480 }}>
        <label>
          Plan
          <select value={planSlug} onChange={(e) => setPlanSlug(e.target.value)}>
            {(plans || []).filter((p) => p.monthly_price_paise > 0).map((p) => (
              <option key={p.slug} value={p.slug}>{p.name}</option>
            ))}
          </select>
        </label>
        <label>
          Billing cycle
          <select value={billingCycle} onChange={(e) => setBillingCycle(e.target.value)}>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </label>
        <button type="button" className="saas-btn saas-btn--primary" onClick={handlePay} disabled={loading}>
          {loading ? "Processing…" : "Upgrade Now"}
        </button>
        {message && <p className="saas-error">{message}</p>}
      </div>
    </div>
  );
}
